import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { analytics } from "../../analytics";
// import SigninPopup from "../popUp/signinPopup";
import { setSignupModalStatus } from "../../actions";

class playerOverlay extends Component {
  constructor(props) {
    super(props);
  }

  openSigninModalPopup = (formName) => {
    if(formName == "signup"){
     analytics("signed_up_end_video");
    }
    this.props.setSignupModalStatus(true, formName);
  };

  render() {
    return (
      <>
      <div className="overlay-wrapper d-flex align-itms-center flex-row justify-content-center">
        <div className="overlay-container align-self-center">
          <p className="overlay-para overlay-new-para">
            To keep watching you’ll need to sign up, we promise you won’t regret it.
          </p>
          <p className="overlay-new-text">ausbiz subscribers get more, and it’s free to join.</p>
          <span
            className="overlay-signin overlay-new-signin"
            onClick={() => this.openSigninModalPopup("signup")}
          >
            Sign up for free
          </span>
          <span className="overlay-signin-help">
            Already have an account? &nbsp;
            <a
              href="javascript:void(null);"
              onClick={() => this.openSigninModalPopup("signin")}
            >
              Sign in here
            </a>
          </span>
        </div>
      </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(playerOverlay);

// export default playerOverlay;
